import { List, ListItem, ListProps } from "@mui/material";
import { VehicleAssessment } from "../../../system/Domain";
import AssessmentDamageListItem from "./AssessmentDamageListItem";

interface Props extends ListProps {
	assessment: VehicleAssessment
}

const AssessmentDamageList = (props: Props) => {
	return (
		<List>
			{props.assessment.damages?.map((d) => <AssessmentDamageListItem key={d.text} damage={d} />)}
			{(!props.assessment.damages || props.assessment.damages.length === 0) && <ListItem>Keine Daten gefunden</ListItem>}
		</List>
	);
};

export default AssessmentDamageList;
